export class SupplierTitle {
  static format(supplier) {
    return (
      (supplier.supplier_id || "") +
      (supplier.supplier_id && supplier.title ? " | " : "") +
      (supplier.title || "")
    );
  }
}
